// extracted by mini-css-extract-plugin
module.exports = {"root":"EasyImageCrop_root__199vC","container":"EasyImageCrop_container__2jxXa"};